<template>
	<box :title="mat" no-padding>
		<table slot="body" class="table table-striped table-hover">
			<thead>
				<tr>
					<th>EXAME</th>
					<th>COD WORKLAB</th>
					<th>VALOR WORKLAB</th>
					<th>VALOR SD2000</th>
				</tr>
			</thead>
			<tbody v-for="(item, index) in exames" :key="index">
				<tr>
					<td>
						<small>{{ item.dataLine.target }}</small
						><br />
						<b
							>{{ item.dataLine.exame }} -
							{{ item.dataLine.linha }}</b
						>
					</td>
					<td>{{ item.id }}</td>
					<td>
						<h4 class="item-value">{{ item.valor }}</h4>
					</td>
					<td>
						<!-- <pre>{{item.dataLine.settings.f}} {{item.importValue}}</pre> -->
						<treated-input-sd2000
							v-model="item.importValue"
							:settings="item.dataLine.settings"
						/>
					</td>
				</tr>
			</tbody>
		</table>
	</box>
</template>
<script>
	import box from 'app/box';
	import TreatedInputSd2000 from './TreatedInputSd2000';

	export default {
		components: {
			box,
			TreatedInputSd2000,
		},
		props: ['exames', 'mat'],
	};
</script>
<style scoped>
	tbody tr td {
		vertical-align: middle;
	}
	.item-value {
		width: 180px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/import/components/item-importacao.vue